import { render, staticRenderFns } from "./BuilderPublish.vue?vue&type=template&id=915136d0"
import script from "./BuilderPublish.vue?vue&type=script&lang=js"
export * from "./BuilderPublish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports